import { UntypedFormGroup, UntypedFormControl, UntypedFormArray, Validators } from '@angular/forms';

import { PcgTableColumn } from '../../../../../table/pcg-table-column.interface';

// tslint:disable:quotemark
// tslint:disable:max-line-length
// tslint:disable:whitespace
export class BarcodeVm {
	barcodeString?: string;
	barcodeId: number;
	tagNumber?: string;
	unit?: string;
	unitId: number;
	client?: string;
	clientId: number;
	canDelete: boolean;
	isUpdatedOffline: boolean;
	offlineId?: any;
	userId?: number;

	static get FormData() {
		return this.getFormData();
	}

	static getFormData(validators = {}) {
		return {
			'barcodeString': new UntypedFormControl(null, [...(validators['barcodeString'] ?? []), ...[]]),
			'barcodeId': new UntypedFormControl(0, [...(validators['barcodeId'] ?? []), ...[Validators.required]]),
			'tagNumber': new UntypedFormControl(null, [...(validators['tagNumber'] ?? []), ...[]]),
			'unit': new UntypedFormControl(null, [...(validators['unit'] ?? []), ...[]]),
			'unitId': new UntypedFormControl(0, [...(validators['unitId'] ?? []), ...[Validators.required]]),
			'client': new UntypedFormControl(null, [...(validators['client'] ?? []), ...[]]),
			'clientId': new UntypedFormControl(0, [...(validators['clientId'] ?? []), ...[Validators.required]]),
			'canDelete': new UntypedFormControl(false, [...(validators['canDelete'] ?? []), ...[]]),
			'isUpdatedOffline': new UntypedFormControl(false, [...(validators['isUpdatedOffline'] ?? []), ...[]]),
			'offlineId': new UntypedFormControl(null, [...(validators['offlineId'] ?? []), ...[]]),
			'userId': new UntypedFormControl(null, [...(validators['userId'] ?? []), ...[]])
		};
	}

	static get Form() {
		return new UntypedFormGroup(this.FormData);
	}

	static get ColumnDefs(): Map<string, PcgTableColumn> {
		return new Map([
			['barcodeId', {"orderId":0,"sortColumn":"barcodeId","searchColumn":"barcodeId","includeInExcel":true,"exportColumn":null,"displayName":"Barcode Id","isVisible":true,"canSearch":true,"multiSearchCellClasses":null}],
			['barcodeString', {"orderId":1,"sortColumn":"barcodeString","searchColumn":"barcodeString","includeInExcel":true,"exportColumn":null,"displayName":"Barcode","isVisible":true,"canSearch":true,"multiSearchCellClasses":null}],
			['tagNumber', {"orderId":2,"sortColumn":"tagNumber","searchColumn":"tagNumber","includeInExcel":true,"exportColumn":null,"displayName":"Tag Number","isVisible":true,"canSearch":true,"multiSearchCellClasses":null}],
			['unit', {"orderId":3,"sortColumn":"unit","searchColumn":"unit","includeInExcel":true,"exportColumn":null,"displayName":"Unit","isVisible":true,"canSearch":true,"multiSearchCellClasses":null}],
			['client', {"orderId":4,"sortColumn":"client","searchColumn":"client","includeInExcel":true,"exportColumn":null,"displayName":"Client","isVisible":true,"canSearch":true,"multiSearchCellClasses":null}],
			['canDelete', {"orderId":5,"sortColumn":"canDelete","searchColumn":"canDelete","includeInExcel":true,"exportColumn":null,"displayName":"Delete","isVisible":true,"canSearch":false,"multiSearchCellClasses":null}]
		]);
	}

	static GetModel(fg: UntypedFormGroup): BarcodeVmFromFg {
		return new BarcodeVmFromFg(fg);
	}
}

export class BarcodeVmFromFg {
	constructor(public fg: UntypedFormGroup) { }


	get barcodeString(): string {
		return this.fg.get('barcodeString').value;
	}
	set barcodeString(val) {
		this.fg.get('barcodeString').setValue(val);
	}

	get barcodeId(): number {
		return this.fg.get('barcodeId').value;
	}
	set barcodeId(val) {
		this.fg.get('barcodeId').setValue(val);
	}

	get tagNumber(): string {
		return this.fg.get('tagNumber').value;
	}
	set tagNumber(val) {
		this.fg.get('tagNumber').setValue(val);
	}

	get unit(): string {
		return this.fg.get('unit').value;
	}
	set unit(val) {
		this.fg.get('unit').setValue(val);
	}

	get unitId(): number {
		return this.fg.get('unitId').value;
	}
	set unitId(val) {
		this.fg.get('unitId').setValue(val);
	}

	get client(): string {
		return this.fg.get('client').value;
	}
	set client(val) {
		this.fg.get('client').setValue(val);
	}

	get clientId(): number {
		return this.fg.get('clientId').value;
	}
	set clientId(val) {
		this.fg.get('clientId').setValue(val);
	}

	get canDelete(): boolean {
		return this.fg.get('canDelete').value;
	}
	set canDelete(val) {
		this.fg.get('canDelete').setValue(val);
	}

	get isUpdatedOffline(): boolean {
		return this.fg.get('isUpdatedOffline').value;
	}
	set isUpdatedOffline(val) {
		this.fg.get('isUpdatedOffline').setValue(val);
	}

	get offlineId(): any {
		return this.fg.get('offlineId').value;
	}
	set offlineId(val) {
		this.fg.get('offlineId').setValue(val);
	}

	get userId(): number {
		return this.fg.get('userId').value;
	}
	set userId(val) {
		this.fg.get('userId').setValue(val);
	}
}
